import styled from "styled-components";
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 22px;
  border-bottom: 1px solid #d1d0cb;
  padding: 8px 0;
  margin: 0 30px;
  background-color: #fafcff;
  &.new-search-header {
    .toggle {
      display: none;
    }
  }
  @media (max-width: 1060px) {
    align-items: flex-end;
  }
  @media (max-width: 850px) {
    margin: 0 15px;
    gap: 0;
  }
`;

const BtnWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px 22px;
  flex-wrap: wrap;
  .car-count {
    font-size: 13px;
  }
  .unselect-checkbox {
    .MuiCheckbox-root {
      display: none;
    }
    .MuiFormControlLabel-label {
      text-decoration: underline;
    }
  }
  .MuiFormControlLabel-label {
    font-size: 13px;
    color: #1d1d1d;
    font-family: "latoregular";
  }
  button {
    border: none;
    background: transparent;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    text-decoration: underline;
    white-space: nowrap;
  }
  @media (max-width: 850px) {
    &.with-search {
      display: grid;
      grid-template-columns: auto 1fr;
      width: 100%;
    }
    gap: 10px 0;
    .MuiFormControlLabel-root {
      margin-left: 0;
    }
    .btn {
      margin-left: -12px;
    }
  }
`;

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding-left: 10px;
    min-height: 30px;
    width: 233px;
  }
  img {
    position: absolute;
    right: 8px;
  }
  @media (max-width: 850px) {
    width: 100%;
    input {
      width: 100%;
    }
  }
`;
const ToggleWrapper = styled.div`
  .MuiToggleButton-standard {
    border: none;
    border-radius: 6px !important;
    padding: 10px;
    @media (max-width: 850px) {
      display: none;
    }
  }
  .MuiToggleButton-root.Mui-selected {
    background-color: #2f3232;
    svg {
      path {
        fill: var(--theme-background);
      }
    }
  }
  .MuiToggleButtonGroup-root {
    border-radius: 0;
    gap: 5px;
  }
`;
const ActionWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px 30px;
  flex-wrap: wrap;
  @media (max-width: 850px) {
    .display {
      display: none;
    }
  }
`;
export { Container, BtnWrapper, SearchWrapper, ToggleWrapper, ActionWrapper };
